
import React, { Component } from "react";
import { Tag, Flex } from 'antd';

class WidgetTagPicker extends React.Component {
    
    constructor( props )
    {
        super( props );

        this.state = {
            selectedTags:[]
        }
    }

    componentWillReceiveProps( nextProps )
    {
        this.setState({selectedTags: nextProps.selectedTags, data:nextProps.date})
    }

    handleChange = (item, checked) => {

        const { pickerType="select" } = this.props;

        let { selectedTags=[] } = this.state;

        if( pickerType==="select" )
        {
            selectedTags = [];

            selectedTags.push(item.value);
        }
        else
        {
            selectedTags.push(item.value);
        }

        this.setState({selectedTags:selectedTags});

        if( this.props.notify )
        {
            this.props.notify(selectedTags, item);
        }
    }

    render()
    {
        const { data=[], title } = this.props;
        
        let { selectedTags = []} = this.state;

        return (
            <div> 
                <Flex gap={4} wrap align="center">
                    {
                        title ? <span>{title}:</span> : <></>
                    }
                    {
                        data.map((item) => (
                            <Tag.CheckableTag
                                key={item.value}
                                checked={selectedTags.includes(item.value)}
                                onChange={(checked) => this.handleChange(item, checked)}
                            >
                                {item.name}
                            </Tag.CheckableTag>
                        ))
                    }
                </Flex>


            </div>
        )
    }
}

export default WidgetTagPicker;